import React, { useEffect, useRef } from 'react';
import { useUnMount } from '@hooks';
import Icon from '@components/Icon';
import { Timer } from '@utils';
import './style.scss';
import ConditionalRenderer, { Else, If } from '@components/ConditionalRenderer';

const Toast = ({
  id,
  type,
  destroy,
  content,
  title,
  link,
  duration = 4500,
}) => {
  const timer = useRef(null);

  const pauseToastMessageTimer = () => timer?.current?.pause();
  const resumeToastMessageTimer = () => timer?.current?.resume();

  useEffect(() => {
    if (!duration) return;

    timer.current = new Timer(() => destroy(), duration);
  }, [destroy, duration]);

  useUnMount(() => clearTimeout(timer.current));

  const toastBody = <>
    <div className='toast-item-icon'>
      <Icon type='info' />
    </div>
    <div>
      {title ? <div className='toast-title title-xs tablet-title-xs mobile-title-lg'>{title}</div> : null}
      {content ? <div className='toast-body text-lg tablet-text-lg mobile-text-lg'>{content}</div> : null}
    </div>
  </>;

  return (
    <ConditionalRenderer condition={link}>
      <If>
        <a
          href={link}
          target='_blank'
          rel='noreferrer'
          className='toast-item-container'
          onMouseEnter={pauseToastMessageTimer}
          onMouseLeave={resumeToastMessageTimer}
        >
          {toastBody}
        </a>
      </If>
      <Else>
        <div
          className='toast-item-container'
          onMouseEnter={pauseToastMessageTimer}
          onMouseLeave={resumeToastMessageTimer}
        >
          {toastBody}
        </div>
      </Else>
    </ConditionalRenderer>
  );
};

const shouldRerender = (prevProps, nextProps) => prevProps.id === nextProps.id;

export default React.memo(Toast, shouldRerender);
